/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUpload = /* GraphQL */ `
  mutation CreateUpload(
    $input: CreateUploadInput!
    $condition: ModelUploadConditionInput
  ) {
    createUpload(input: $input, condition: $condition) {
      id
      reportinguser
      reportedservice
      reportednumber
      reportedemail
      reportedusername
      reportedfirstname
      reportedlastname
      reportedcomment
      createdAt
      updatedAt
    }
  }
`;
export const updateUpload = /* GraphQL */ `
  mutation UpdateUpload(
    $input: UpdateUploadInput!
    $condition: ModelUploadConditionInput
  ) {
    updateUpload(input: $input, condition: $condition) {
      id
      reportinguser
      reportedservice
      reportednumber
      reportedemail
      reportedusername
      reportedfirstname
      reportedlastname
      reportedcomment
      createdAt
      updatedAt
    }
  }
`;
export const deleteUpload = /* GraphQL */ `
  mutation DeleteUpload(
    $input: DeleteUploadInput!
    $condition: ModelUploadConditionInput
  ) {
    deleteUpload(input: $input, condition: $condition) {
      id
      reportinguser
      reportedservice
      reportednumber
      reportedemail
      reportedusername
      reportedfirstname
      reportedlastname
      reportedcomment
      createdAt
      updatedAt
    }
  }
`;
